/**
 * Administracion de usuarios creadores departamentales
 */
/* eslint-disable */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_USUARIOS_CREADORES = "obtenerCreadoresDepartamentales";
export const OBTENER_USUARIO_CREADOR = "obtenerCreadorDepartamental";
export const REGISTRAR_USUARIO_CREADOR = "registrarCreadorDepartamental";
export const ACTUALIZAR_USUARIO_CREADOR = "actualizarCreadorDepartamental";
// mutation types
export const SET_USUARIOS_CREADORES = "setUsuariosCreadores";
export const SET_USUARIO_CREADOR = "setUsuarioCreador";


const state = {
    usuariosCreadores: [],
    usuarioCreador:[],
}

const getters = {
    obtenerusuariosCreadores(state) {
      return state.usuariosCreadores;
    },
}

const actions = {

    /**
     * Obtener los usuarios creadores departamentales
     * @param {*} context 
     * @returns 
     */
    async [OBTENER_USUARIOS_CREADORES](context) {

       
        /*
        * Si el estado es null va a traer a todas los usuariosCreadores, de lo contrario va a traer los usuariosCreadores por estado
        *
        */
        let endpoint = `api/Usuarios/Rol/${5}`
       /* if(estadoId){
            endpoint = `api/usuarioCreador/Estado/${estadoId}`
        }*/

        return new Promise(resolve => {
            ApiService.get(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_USUARIOS_CREADORES, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });     
    },

    /**
     * Obtener la información de un usuario específico (Creador Departamental)
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_USUARIO_CREADOR](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Usuarios/`)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_CREADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
      
    /**
     * Registrar un usuario Creador
     * @param {} context 
     * @param {*} datosUsuario 
     * @returns 
     */

    async [REGISTRAR_USUARIO_CREADOR](context, datosUsuario){
        
        datosUsuario.rolUsuarioId = 5;
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_CREADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    /**
     * Actaulizar datos del usuario
     * @param {*} context 
     * @param {*} datosUsuario 
     * @returns 
     */
    async [ACTUALIZAR_USUARIO_CREADOR](context, datosUsuario){
        let id = datosUsuario.id;
       
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Usuarios/`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_CREADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },   

}

const mutations = {
    [SET_USUARIOS_CREADORES](state, data) {
        state.usuariosCreadores = data;
    },

    [SET_USUARIO_CREADOR](state, data) {
        state.usuarioCreador = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}